import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { metricsStyleSelector, getChangeType } from 'utils/metricesHelper';

const TotalChange = ({ comparisonInterval, changeValue }) => {
  const changeType = getChangeType(changeValue);
  const comparisonIcon = metricsStyleSelector(changeType, changeValue);
  const { icon, fontClass } = comparisonIcon;
  const className = `${fontClass} font-weight-bold`;
  const noChange = changeType === 'constant';
  const changeText = noChange ? null : `${changeValue.toString().replace('-', '')}`;

  return (
    <div className="metrics-comparison">
      <FontAwesomeIcon className={'dash-svg ' + className} icon={icon} />
      <span className={'dash-span ' + className}>
        {changeText}
        {' '}
      </span>
      {!noChange ? `from ${comparisonInterval}` : 'No change'}
    </div>
  );
};

TotalChange.propTypes = {
  comparisonInterval: PropTypes.string,
  changeValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

TotalChange.defaultProps = {
  changeValue: 0,
  comparisonInterval: '',
};

export default TotalChange;



// WEBPACK FOOTER //
// ./src/components/dashboard/number/TotalChange.js